const institutions = [
	{
		value: -1,
		label: 'Alege'
	},
	{
		value: 0,
		label: 'Şcoala de Agenţi de Poliţie „Vasile Lascăr” - Câmpina',
		shortLabel: 'SAP CÂMPINA'
	},
	{
		value: 1,
		label: 'Şcoala de Agenţi de Poliţie „Septimiu Mureşan” Cluj',
		shortLabel: 'SAP CLUJ'
	},
	{
		value: 2,
		label: 'Şcoala Militară de Subofiţeri de Jandarmi „Grigore Alexandru Ghica” - Drăgăşani',
		shortLabel: 'SMSJ DRĂGĂȘANI'
	},
	{
		value: 3,
		label: 'Şcoala Militară de Subofiţeri Jandarmi Fălticeni',
		shortLabel: 'SMSJ FĂLTICENI'
	},
	{
		value: 4,
		label: 'Şcoala de Pregătire a Agenţilor Poliţiei de Frontieră „Avram Iancu” - Oradea',
		shortLabel: 'SPAP ORADEA'
	},
	{
		value: 5,
		label: 'Academia de Poliție „Alexandru Ioan Cuza” - București',
		shortLabel: 'ACADEMIA AIC'
	}
];

export function getInstitutionName(value, largeScreen) {
	let label;
	institutions.forEach((institution) => {
		if (institution.value === value) {
			if (largeScreen) {
				label = institution.label;
			} else {
				label = institution.shortLabel;
			}
		}
	});

	return label;
}

export default institutions;
